import React, { useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import TourDetails from './components/TourDetails';
import Pricing from './components/Pricing';
import Itinerary from './components/Itinerary';
import Booking from './components/Booking';
import Footer from './components/Footer';
import { trackPageView } from './utils/analytics';
import './App.css';

function App() {
  useEffect(() => {
    trackPageView('Devil\'s Highway Motorcycle Tours - Home');
  }, []);

  useEffect(() => {
    const hash = window.location.hash.replace('#', '');
    if (!hash) return;

    const scrollToHash = () => {
      const element = document.getElementById(hash);
      if (element) {
        element.scrollIntoView();
      }
    };

    const timeoutId = window.setTimeout(scrollToHash, 80);
    return () => window.clearTimeout(timeoutId);
  }, []);

  return (
    <div className="App">
      <Header />
      <Hero />
      <TourDetails />
      <Itinerary />
      <Pricing />
      <Booking />
      <Footer />
    </div>
  );
}

export default App;
